import { MessageDescriptor } from 'react-intl';

export const getLabel = (isBreakdown: boolean, isAtDealership: boolean): MessageDescriptor =>{
  let label: MessageDescriptor = {
    id:'login.askLicensePlate',
    defaultMessage:'Please enter the license plate of your vehicle in order to access your appointment'
  };

  if (isBreakdown) {
    label = {
      id:'login.askPlateBreakdown',
      defaultMessage:'Please enter your phone number and the license plate of the vehicle.'
    };
  }

  if (isAtDealership) {
    label = {
      id:'login.askLicensePlateAndId',
      defaultMessage:'Please enter your license plate and the kiosk\'s location ID in order to access your appointment.'
    };
  }

  return label;
};